import styled, { css, keyframes } from 'styled-components';
import { switchProp } from 'styled-tools';

const COLORS = {
  white: '#ffffff',
  ligthGrey: '#E0E0E0',
  darkGrey: '#858585',
  labelSmall: '##BDBDBD',
  buttonGreen: '#009688',
  buttonHoverGreen: '#01BEA4',
  disabledGrey: '#E0E0E0',
};

const animationInDefault = keyframes`
  0% { 
    top: 50px; 
    opacity: 0; 
  }
  
  100% { 
    top: 100px; 
    opacity: 1; 
  }
`;

const animationInProposal = keyframes`
  0% { 
    left: 50px; 
    opacity: 0; 
  }
  
  100% { 
    left: 0; 
    opacity: 1; 
  }
`;

const Container = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  font-size: 10px;
  font-family: 'Montserrat';
  left: 550px;
  opacity: 0;

  ${switchProp('theme', {
    default: css`
      animation: ${animationInDefault} 0.7s 0.4s forwards;
      position: absolute;
      top: 100px;
    `,
    proposal: css`
      animation: ${animationInProposal} 0.5s forwards;
      position: relative;
      left: 0;
    `,
  })}
`;

const Title = styled.h1`
  font-size: 2.4em;
  font-weight: 300;
`;

const Subtitle = styled.h1`
  color: #a5a9b4;
  font-size: 1.6em;
  font-weight: 300;
  margin-top: 5px;
`;

const disabledForm = css`
  opacity: 0.4 !important;
  pointer-events: none;
`;

const Form = styled.form`
  ${({ isDisabled }) => (isDisabled ? disabledForm : null)};

  margin-top: 30px;
  opacity: 1;
  transition: all 0.5s ease-in-out;
`;

const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  label {
    margin-bottom: 15px !important;
  }
`;

const InputColumn = styled.div`
  width: ${({ size }) => size || '100%'};
`;

const ButtonContainer = styled.div`
  ${switchProp('theme', {
    default: css`
      display: flex;
      font-family: 'Montserrat';
      font-size: 10px;
      justify-content: flex-end;
      padding-top: 20px;
    `,
    proposal: css`
      display: none;
    `,
  })}
`;

const buttonDisabledTheme = css`
  background-color: ${COLORS.disabledGrey};
  border: 2px solid ${COLORS.disabledGrey};
  pointer-events: none;
  color: ${COLORS.darkGrey};
`;

const buttonActiveTheme = css`
  background-color: ${COLORS.buttonGreen};
  border: 2px solid ${COLORS.buttonGreen};
  color: ${COLORS.white};

  &:hover {
    background-color: ${COLORS.buttonHoverGreen};
    border-color: ${COLORS.buttonHoverGreen};
  }
`;

const getButtonTheme = theme => {
  return {
    disabled: buttonDisabledTheme,
    active: buttonActiveTheme,
  }[theme];
};

const ButtonConfirm = styled.button`
  background-color: #009688;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-size: 1.5em;
  font-weight: 600;
  padding: 15px 0;
  transition: background-color 0.15s ease-in-out;
  width: 165px;

  ${({ theme }) => getButtonTheme(theme)};
`;

const ButtonCancel = styled.button`
  background-color: #ffffff;
  border: none;
  color: #009688;
  cursor: pointer;
  font-size: 1.5em;
  font-weight: 600;
  margin-right: 10px;
  padding: 15px 30px;
`;

export {
  Container,
  Title,
  Subtitle,
  Form,
  InputRow,
  InputColumn,
  ButtonContainer,
  ButtonConfirm,
  ButtonCancel,
};
